// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r3-0";
export var leftAlign = "_r3-4";
export var listItem = "_r3-2";
export var listItemWrapper = "_r3-1";
export var operationText = "_r3-3";